import React from 'react';
import { Select } from 'antd';

const ReportCompanySelect = ({
  companies,
  value,
  onChange,
  loading = false,
}) => {
  if (!companies || companies.length <= 1) {
    return null;
  }

  return (
    <div className="flex flex-col gap-1">
      <span className="text-xs text-slate-500">Şirket</span>
      <Select
        value={value}
        onChange={onChange}
        placeholder="Şirket seçiniz"
        className="w-full"
        loading={loading}
      >
        {companies.map((company) => (
          <Select.Option key={company.SirketKodu} value={company.SirketKodu}>
            {company.SirketAdi || company.SirketKodu}
          </Select.Option>
        ))}
      </Select>
    </div>
  );
};

export default ReportCompanySelect;
